import { ShieldCheck, HandCoins, Ban } from "lucide-react";
import { SAFETY_TIPS } from "@/lib/constants";

export default function Safety() {
  return (
    <div className="mx-auto max-w-3xl px-4 py-14 sm:px-6">
      <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#d4f253]">Trust & safety</p>
      <h1 className="mt-2 font-display text-4xl font-extrabold tracking-tight sm:text-5xl">Pay on pick-up. Always.</h1>
      <p className="mt-4 text-slate-300">ISoldIt is a free noticeboard connecting local buyers and sellers. We never hold, process or release payments — you deal directly with each other, face to face.</p>
      <div className="mt-10 grid gap-4 sm:grid-cols-3">
        {[{ i: HandCoins, t: "Pay in person", d: "Cash or PayID once you've seen the item." }, { i: Ban, t: "No deposits", d: "Never send money before pick-up." }, { i: ShieldCheck, t: "Chat in-app", d: "Keep your number private until you're ready." }].map((x) => (
          <div key={x.t} className="rounded-2xl bg-[#173742] p-6"><x.i className="h-7 w-7 text-[#d4f253]" /><h3 className="mt-3 font-bold">{x.t}</h3><p className="mt-1 text-sm text-slate-400">{x.d}</p></div>
        ))}
      </div>
      <ul data-testid="safety-tips-list" className="mt-10 space-y-3">
        {SAFETY_TIPS.map((t, i) => <li key={t} className="flex gap-4 rounded-xl border border-white/10 p-4 text-sm"><span className="font-display font-extrabold text-[#d4f253]">0{i + 1}</span>{t}</li>)}
      </ul>
    </div>
  );
}
